<template>
  <div>
    <SearchUsersForm
      :business-id="businessId"
      ref="SearchUsersForm"
      :reservation-errors="reservationErrors"
      :show-add-user="true"
      @setUser="
        userDetails =>
          (reservationModel.reserved_for_id = userDetails
            ? userDetails.id
            : null)
      "
    />

    <div ref="reservationForm">
      <b-form-group label="Status">
        <b-form-select plain v-model="reservationModel.status">
          <b-form-select-option :value="ReservationStatuses.pending">
            {{ ReservationStatuses.pending }}
          </b-form-select-option>
          <b-form-select-option :value="ReservationStatuses.completed">
            {{ ReservationStatuses.completed }}
          </b-form-select-option>
          <b-form-select-option :value="ReservationStatuses.canceled">
            {{ ReservationStatuses.canceled }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Booking dates">
        <date-picker v-model="defaultRange" range></date-picker>
      </b-form-group>

      <b-form-group label="Invoices">
        <InvoicesList
          :invoices-data="invoices"
          :businessId="businessId"
          :branchId="branchId"
          @updateInvoices="data => (reservationModel.invoices = data)"
        />
      </b-form-group>
      <b-form-group label="Notes">
        <NotesList
          :notes-data="reservationModel.notes"
          @updateNotes="data => (reservationModel.notes = data)"
        />
      </b-form-group>
    </div>

    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
    <div v-else>
      <b-button variant="primary" @click="createReservation">
        Submit
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { ReservationStatuses } from "@/config/constant";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { __assetDimensioned } from "@/helpers/helpers";
import SearchItemsForm from "./SearchItemsForm.vue";
import SearchUsersForm from "./SearchUsersForm.vue";
import NotesList from "./NotesList.vue";
import InvoicesList from "./InvoicesList.vue";
import { submitAndNotify } from "@/helpers/utils";
import { createReservation } from "@/API/ReservationsAPIs";
import { InvoiceColor } from "@/config/Invoices";
export default {
  name: "QuickReservation",
  components: {
    DatePicker,
    SearchItemsForm,
    SearchUsersForm,
    NotesList,
    InvoicesList
  },
  props: ["businessId", "branchId", "reservationDate", "item"],
  data: function() {
    return {
      loading: false,
      defaultRange: [],
      calendarDates: {
        startDate: null,
        endDate: null
      },
      invoices: [],
      reservationModel: {
        businessId: null,
        branchId: null,
        reservable_type: "App\\Models\\Item",
        reserved_for_id: null,
        status: "pending",
        from: null,
        to: null,
        invoices: [],
        notes: []
      },
      reservationErrors: {
        startDate: "",
        endDate: "",
        user: ""
      }
    };
  },
  computed: {
    ReservationStatuses() {
      return ReservationStatuses;
    }
  },
  mounted() {
    let dates = this.reservationDate;
    this.defaultRange = [
      moment(dates).toDate(),
      moment(dates)
        .add(1, "days")
        .toDate()
    ];

    this.reservationModel.branchId = this.branchId;
    this.reservationModel.businessId = this.businessId;
  },
  methods: {
    InvoiceColor,
    async createReservation() {
      this.loading = true;
      const action = {
        ...this.reservationModel,
        reservable_id: this.item.id
      };

      const callback = response => {
        this.loading = false;
        this.calendarDates.startDate = "";
        this.calendarDates.endDate = "";
        this.$bvModal.hide("reservation-modal");
      };

      await submitAndNotify(
        this,
        createReservation(action),
        callback,
        "Booking successfully created",
        "Failed to create booking"
      );
    },
    isValidData() {
      this.reservationErrors.startDate = "";
      this.reservationErrors.endDate = "";
      let isValid = true;
      if (!this.reservationModel.reserved_for_id) {
        this.reservationErrors.user = " Please select a user";
        isValid = false;
      }
      if (!this.calendarDates.startDate) {
        this.reservationErrors.startDate = "This field is required";
        isValid = false;
      }
      this.invoices.forEach(function(invoice) {
        if (invoice.amount === 0) {
          invoice.validationMessage = "This field is required";
          isValid = false;
        }
      });
      return isValid;
    }
  },
  watch: {
    reservationDate: {
      deep: true,
      handler(x) {
        this.defaultRange = [
          moment(x).format("YYYY-MM-DDT14:00:00.000Z"),
          moment(x).format("YYYY-MM-DDT14:00:00.000Z")
        ];
      }
    },
    defaultRange: {
      deep: true,
      handler(val) {
        this.reservationModel.from = moment(val[0]).format("YYYY-MM-DDTHH:mm");
        this.reservationModel.to = moment(val[1])
          .endOf("day")
          .format("YYYY-MM-DDTHH:mm");
      }
    }
  }
};
</script>

<style lang="css"></style>
